<template>
  <div class="alert_bannr">
    <img class="pc" :src="imagePath">
    <img class="sp" :src="imagePathSp">
  </div>
</template>

<script>
export default {
  props: {
    imagePath: {
      type: String,
      default: '',
    },
    imagePathSp: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.alert_bannr {
  text-align: center;
  margin: 0 20px;
  img {
    border-radius: 10px;
    width: 100%;
    max-width: 1200px;
    margin: auto;
  }
}
.pc {
  display: block;
}
.sp {
  display: none;
}
@media screen and (max-width: $tabletWidth) {
  .alert_bannr {
    padding-top: 10px;
  }
  .pc {
    display: none;
  }
  .sp {
    display: block;
  }
}
</style>
